// @ts-nocheck
import React from 'react'
import { useTranslation } from 'react-i18next'

import NoContent from 'src/parser/shared/PDF/NoContent'
import { PDFError } from 'src/parser/shared/PDF/PDFError'
import Table from '../Table'
import { TSectionContent } from 'src/parser/shared/PDF/Sections'
import {
  stripBidi,
  normalizeArabicComma,
} from 'src/parser/shared/PDF/Title/CommonUtils'
import Loadable from 'src/utils/Loadable'

const UserTasks: TSectionContent = ({ tasks }) => {
  const { t } = useTranslation()

  if (Loadable.isFailure(tasks)) return <PDFError error={tasks.error} />

  if (tasks.data.length === 0) return <NoContent />

  return (
    <Table
      columns={{
        date: {
          title: t('alarm_report.user_tasks.date'),
          render: createdAt => {
            return normalizeArabicComma(
              stripBidi(
                t('alarm_report.logs.date_format', {
                  date: new Date(createdAt),
                }),
              ),
            )
          },
          style: {
            flex: 0.2,
          },
        },
        description: {
          title: t('alarm_report.user_tasks.description'),
          render: v => v,
          style: {
            flex: 0.325,
          },
        },
        answers: {
          title: t('alarm_report.user_tasks.selected_answers'),
          render: answers => answers?.join(','),
          style: {
            flex: 0.15,
          },
        },
        notes: {
          title: t('alarm_report.user_tasks.notes'),
          render: v => v,
          style: {
            flex: 0.325,
          },
        },
        completedBy: {
          title: t('alarm_report.user_tasks.completed_by'),
          render: v => v?.userName,
          style: {
            flex: 0.15,
          },
        },
      }}
      rows={tasks.data.map(task => ({
        date: task.createdAt,
        description: task.description,
        answers: task.selectedAnswers,
        notes: task.notes,
        completedBy: task.completedBy,
      }))}
      getRowKey={task => task.date.toString()}
    />
  )
}

export default UserTasks
